import { Mail, MessageCircle, MessageSquare } from "lucide-react";
import { Panel, Empty } from "@/components/PageHeader";
import { fdatetime } from "@/lib/api";

const ICON = { email: Mail, sms: MessageSquare, whatsapp: MessageCircle };
const LABEL = { email: "Email", sms: "SMS", whatsapp: "WhatsApp" };

export const CustomerMessages = ({ rows }) => (
  <Panel testId="customer-messages">
    {rows.length === 0 ? <Empty text="Nessun messaggio inviato a questo cliente." /> : rows.map((m) => {
      const Icon = ICON[m.channel];
      return (
        <div key={m.id} className="border-b border-slate-100 px-5 py-3 last:border-0" data-testid={`customer-message-${m.id}`}>
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-2 text-sm text-slate-800"><Icon className="h-4 w-4 text-slate-400" />{LABEL[m.channel]} a <span className="font-mono text-xs">{m.to}</span></div>
            <span className={`rounded-full px-2 py-0.5 text-[11px] font-medium ${m.status === "inviato" ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700"}`}>{m.status}</span>
          </div>
          {m.subject && <div className="mt-1 text-sm font-medium text-slate-900">{m.subject}</div>}
          <div className="mt-1 whitespace-pre-wrap text-sm text-slate-600">{m.body}</div>
          {m.error && <div className="mt-1 text-xs text-rose-600">{m.error}</div>}
          <div className="mt-1 text-xs text-slate-400">{fdatetime(m.created_at)} · {m.sent_by}</div>
        </div>
      );
    })}
  </Panel>
);
